/* Кнопка «↑ BACK TO TOP» на главной и переходы с первого экрана
   (вариант 7, утверждён Billionaire 12.10.2026; компьютер — 12.10.2026).

   - Кнопка закреплена справа внизу, видна только когда первый экран ушёл
     вверх и не закрывает ни одной кнопки/ссылки страницы.
   - По нажатию — плавно к кнопкам первого экрана с учётом липкой шапки;
     при «уменьшить движение» — без анимации.
   - Ссылки первого экрана (#pi-plans, #pi-day, #pi-shuttle, #pi-area) кладут
     шаг в историю, поэтому системная «Назад» возвращает наверх.
   Работает на любой ширине: берёт тот первый экран, который сейчас виден
   (.pi-mobile на телефоне/планшете, .pi-exact на компьютере). */
(function () {
  'use strict';

  function init() {
    var HEROES = [].slice.call(document.querySelectorAll(
      '.pi-mobile [data-pencil-name="01 Hero"], .pi-exact [data-pencil-name="01 Hero"]'));
    if (!HEROES.length) return;
    /* видимый первый экран (второй скрыт display:none и не имеет прямоугольников) */
    function hero() {
      for (var i = 0; i < HEROES.length; i++) if (HEROES[i].getClientRects().length) return HEROES[i];
      return HEROES[0];
    }
    function hbOf(h) { return h.querySelector('[data-pencil-name="Hero Buttons"]') || h; }
    function inHero(e) { for (var i = 0; i < HEROES.length; i++) if (HEROES[i].contains(e)) return true; return false; }
    var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var BEH = RM ? 'auto' : 'smooth';
    var base = location.href.split('#')[0];

    function headerH() {
      var y = 0;
      [[innerWidth / 2, 2], [20, 2]].forEach(function (p) {
        var e = document.elementFromPoint(p[0], p[1]);
        while (e && e !== document.body && e !== document.documentElement) {
          if (e.id === 'pi-back') break;
          var ps = getComputedStyle(e).position;
          if (ps === 'sticky' || ps === 'fixed') {
            var r = e.getBoundingClientRect();
            if (r.top <= 2 && r.height < 160) y = Math.max(y, r.bottom);
            break;
          }
          e = e.parentElement;
        }
      });
      return Math.round(y);
    }
    function heroY() {
      var h = hero(), hb = hbOf(h), wl = hb.querySelector('a.pi-wait') || h.querySelector('a.pi-wait') || hb;
      var t = hb.getBoundingClientRect(), w = wl.getBoundingClientRect(), hh = headerH();
      var y = Math.max(0, scrollY + w.bottom + 24 - innerHeight);
      var top = scrollY + t.top - hh - 16;
      if (y > top) y = Math.max(0, top);
      return Math.round(y);
    }
    function secY(el) { return Math.max(0, Math.round(el.getBoundingClientRect().top + scrollY - headerH())); }
    function byId(id) {
      var L = [].slice.call(document.querySelectorAll('[id="' + id + '"]')), i;
      var cv = hero().closest('.pi-mobile, .pi-exact');
      for (i = 0; i < L.length; i++) if (L[i].getClientRects().length && cv && cv.contains(L[i])) return L[i];
      for (i = 0; i < L.length; i++) if (L[i].getClientRects().length) return L[i];
      return null;
    }
    function target(hash) {
      var id = (hash || '').replace(/^#/, '');
      if (!id) return null;
      return byId(id) || byId(id + '-m');
    }
    var upd = null;
    function go(y) {
      try { window.scrollTo({ top: y, behavior: BEH }); } catch (e) { window.scrollTo(0, y); }
      setTimeout(function () { if (upd) upd(); }, BEH === 'smooth' ? 900 : 30);
    }
    function reveal() { document.documentElement.style.setProperty('--pi-cv', 'visible'); }

    /* ссылки первого экрана: href читаем в момент нажатия — pi-nav.js
       к этому времени уже переписал #pi-plans → #pi-plans-m и т.п.
       Слушаем на window в фазе захвата — раньше обработчика #pi-area в pi-nav.js
       (тот заменяет запись истории, а нам нужен новый шаг для «Назад»). */
    addEventListener('click', function (ev) {
      if (ev.defaultPrevented || ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href^="#"]') : null;
      if (!a || a.id === 'pi-back' || !inHero(a)) return;
      reveal();
      var el = target(a.getAttribute('href'));
      if (!el) return;
      ev.preventDefault();
      ev.stopPropagation();
      try { history.pushState({ pi: 'hero' }, '', base + '#' + el.id); } catch (e) {}
      /* после снятия content-visibility раскладка меняется — меряем в следующем кадре */
      requestAnimationFrame(function () { go(secY(el)); });
    }, true);
    addEventListener('popstate', function () {
      var hs = location.hash.slice(1), el = hs && hs.indexOf('pi-') === 0 ? target(hs) : null;
      reveal();
      if (el) go(secY(el)); else go(heroY());
    });

    /* кнопка */
    var lab = hbOf(hero()).querySelector('[data-pencil-name="Label"]');
    var lcs = lab ? getComputedStyle(lab) : null;
    var bb = document.createElement('a');
    bb.id = 'pi-back';
    bb.href = '#top';
    bb.setAttribute('aria-label', 'Back to top');
    bb.textContent = '↑ BACK TO TOP';
    bb.style.cssText =
      'position:fixed;z-index:60;right:calc(16px + env(safe-area-inset-right,0px));' +
      'bottom:calc(16px + env(safe-area-inset-bottom,0px));min-height:44px;min-width:44px;' +
      'box-sizing:border-box;display:flex;align-items:center;justify-content:center;padding:0 18px;' +
      'border-radius:999px;background:#08331B;color:#E9A83A;border:1px solid rgba(233,168,58,.6);' +
      'box-shadow:0 4px 14px rgba(8,51,27,.28);text-decoration:none;white-space:nowrap;' +
      '-webkit-tap-highlight-color:transparent;' +
      (lcs ? 'font-family:' + lcs.fontFamily + ';font-weight:' + lcs.fontWeight + ';' : '') +
      'font-size:11.5px;letter-spacing:1.2px;line-height:1;' +
      'opacity:0;visibility:hidden;pointer-events:none;transform:translateY(8px);' +
      (RM ? '' : 'transition:opacity .25s ease,transform .25s ease,visibility 0s linear .25s;');
    document.body.appendChild(bb);

    function show(v) {
      bb.style.opacity = v ? '1' : '0';
      bb.style.visibility = v ? 'visible' : 'hidden';
      bb.style.pointerEvents = v ? 'auto' : 'none';
      bb.style.transform = v ? 'none' : 'translateY(8px)';
      if (!RM) bb.style.transition = v
        ? 'opacity .25s ease,transform .25s ease,visibility 0s'
        : 'opacity .25s ease,transform .25s ease,visibility 0s linear .25s';
    }
    var cands = [].slice.call(document.querySelectorAll(
      '.pi-mobile a, .pi-mobile button, .pi-mobile [data-pencil-name^="Button"], .pi-mobile input, .pi-mobile select,' +
      ' .pi-exact a, .pi-exact button, .pi-exact [data-pencil-name^="Button"], .pi-exact [data-pencil-name$="CTA"], .pi-exact input, .pi-exact select'
    )).filter(function (e) { return !inHero(e); });
    function overlap() {
      var r0 = bb.getBoundingClientRect(), sh = (bb.style.transform && bb.style.transform !== 'none') ? 8 : 0, m = 12;
      var r = { left: r0.left, right: r0.right, top: r0.top - sh, bottom: r0.bottom - sh };
      if (!r0.width) r = { left: innerWidth - 170, right: innerWidth - 16, top: innerHeight - 60, bottom: innerHeight - 16 };
      for (var i = 0; i < cands.length; i++) {
        var c = cands[i].getBoundingClientRect();
        if (!c.width || !c.height) continue;
        if (c.bottom < r.top - m || c.top > r.bottom + m) continue;
        if (c.right < r.left - m || c.left > r.right + m) continue;
        return true;
      }
      return false;
    }
    upd = function () {
      var heroOut = hero().getBoundingClientRect().bottom <= headerH() + 1;
      show(heroOut && !overlap());
    };
    var tick = false, tmo = 0;
    addEventListener('scroll', function () {
      clearTimeout(tmo); tmo = setTimeout(upd, 120);
      if (tick) return; tick = true;
      requestAnimationFrame(function () { tick = false; upd(); });
    }, { passive: true });
    addEventListener('resize', upd);
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function () { upd(); }, { threshold: 0 });
      HEROES.forEach(function (h) { io.observe(h); });
    }
    bb.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (history.state && history.state.pi === 'hero') history.back();
      else { try { history.replaceState(null, '', base); } catch (e) {} go(heroY()); }
    });
    upd();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
